import { z } from '@/libs/zod';

export const ROUTES = z.enum([
  '/',
  '/health',
  '/meus-titulos',
  '/resultados',
  '/checkout',
  '/jogo/giro-da-sorte',
  '/jogo/raspadinha-da-sorte',
  '/jogo/piao-da-sorte',
  '/sobre-nos',
  '/suporte',
  '/carteira',
  '/carteira/saque',
  'meus-titulos/titulos-por-compra',
  'detalhes',
  '/detalhes',
]);
